//burger-menu --- start ---
if(window.innerWidth <= 978){
    const html = document.querySelector('html')
    const togglerSidebar = document.querySelector('#toggle-sidebar')

    // open/close sideBar
    togglerSidebar.addEventListener('click', ()=>{
        if(html.classList.contains('sidebar_open')){
            html.classList.remove('sidebar_open')
        }else {
            html.classList.add('sidebar_open')
        }

    })

    let scrollCount = 0;
    window.addEventListener('scroll',()=>{
        // scroll with scrollbar
        if(window.scrollY > 0){
            html.classList.add('__scroll-down')
        }else {
            html.classList.remove('__scroll-down')
        }

        // when down scrolling scrollBar is hidden. If up scrolling scrollBar is show
        window.scrollY > scrollCount && window.scrollY > 0 ? !html.classList.contains('scroll') && html.classList.add('scroll') : html.classList.contains('scroll') && html.classList.remove('scroll'),  scrollCount = window.scrollY
    })

    // toggle tabs
    const menuTabs = document.querySelectorAll('#burger-menu .burger-menu_categories .categories_item')
    const menuContents = document.querySelectorAll('#burger-menu .burger-menu_contents .content_item')

    menuTabs.forEach((tabItem,index) =>{
        tabItem.addEventListener('click',function (){

            menuTabs.forEach((tabItem,index)=>{
                tabItem.classList.remove('active')
                menuContents[index].classList.remove('active')
            })

            this.classList.add('active')
            menuContents[index].classList.add('active');


        })
    })


    //close burger menu
    html.addEventListener('click',(event)=>{
        if(html.classList.contains('sidebar_open')) {
            if(event.target.closest('nav') === null){
                html.classList.remove('sidebar_open')
            }
        }
    })


}

// --- end ---
